import * as React from 'react';

function SvgIconWallet(props) {
  return (
    <svg width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.906 2.406H3.094a.687.687 0 00-.688.688v15.812c0 .38.307.688.688.688h15.812c.38 0 .688-.308.688-.688V3.094a.687.687 0 00-.688-.688zm-.687 9.969h-6.875v-2.75h6.875v2.75zM12.46 11a.86.86 0 101.72 0 .86.86 0 00-1.72 0z"
        fill="#000"
        fillOpacity={0.65}
      />
    </svg>
  );
}

export default SvgIconWallet;
